import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Paper, Typography, Grid } from '@mui/material';
import ResponsiveAppBar from './ResponsiveAppBar';
import img from './../Media/images/family.png'

const mapUserDataState = ({user}) => ({
  userProfileData: user.userProfileData
})

function Header(props) {

  const { userProfileData } = useSelector(mapUserDataState)


  return (
    <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'space-between', backgroundColor:'#181824', height:80, width:'100%', mb:{xs:0, md:10}}}>
      <Grid container alignItems='center' justifyContent='center'>
        <Grid item display={{xs:'none', md:'flex'}}>
          <img src={img} height='85'/>
        </Grid>
        <Grid item alignItems='center'>
          <Grid item>
            <Typography variant='h3' color='silver' fontSize={{xs:20, md:50}}>
              {userProfileData ? userProfileData.displayName ? userProfileData.displayName : userProfileData.firstName + ' ' + userProfileData.lastName  : 'ZOE INC. & ASSOCIATES'}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
        <ResponsiveAppBar appBarProps={props}/>
    </Box>
  );
}

export default Header;
